import React from 'react';

import { performApiRequest, KATOTTG_GETCHILDREN_API_URL} from '../../util/restapi';

const MODE_POPULATING = 'mp';
const MODE_ERROR = 'me';
const MODE_READY = 'mr';

class KatottgNode extends React.Component {

	record;
	children = null;
	errorMessage = '';
	
	constructor(props) {
		super(props);
		this.record = props.record;
		this.state = {
			mode: MODE_READY,
			isCollapsed: true,
			dirtyCounter: 0
		};
	}

	handleCheckBoxChange = (e) => {
		let tree = this.props.tree;
		if( e.target.checked ) {
			tree.setSelectedNode( this );
		} else {
			tree.setSelectedNode( null );
		}
		this.setState({dirtyCounter: this.state.dirtyCounter + 1});
	}
	
	expand = async () => {
		this.setState( { isCollapsed: false } );
		if( this.children == null && this.state.mode == MODE_READY ) {
			await this.populateChildren();
		}
	}
	collapse = () => {
		this.setState( { isCollapsed: true } );
	}
	updateRecord = (record) => {
		this.record = record;
		this.setState({dirtyCounter: this.state.dirtyCounter + 1});
	}
	populateChildren = async () => {
		this.setState( { mode: MODE_POPULATING } );
		let getChildrenRequest = {
			code: this.record.code,
		}
		let response = await performApiRequest( KATOTTG_GETCHILDREN_API_URL, getChildrenRequest );
		if( ! response.success ) {
			this.errorMessage = response.message;
			this.setState({mode: MODE_ERROR})
			return;
		}
		this.children = response.listKatottgRecord;
		this.setState({mode: MODE_READY})
	}

	render() {
		let childrenHtml = null;
		if( this.state.mode == MODE_POPULATING ) {
			childrenHtml = <div>...</div>
		} else if( ! this.state.isCollapsed ) {
			if( this.state.mode == MODE_READY ) {
				childrenHtml = this.children.map( (record, index) => {
					return <KatottgNode key={index} tree={this.props.tree} record={record} />
				} );
			} else if( this.state.mode == MODE_ERROR ) {
				childrenHtml = ( <div>{this.errorMessage}</div> );
			}
		}
		return (
			<div style={{padding: '5px'}}>
				<HeaderRow holder={this} />
				<div style={{marginLeft: '50px'}}>
					{childrenHtml}
				</div>
			</div>
		)
	}
}

function HeaderRow(props) {
	let buttonStyle = {width: '22px'}
	let holder = props.holder;
	let tree = holder.props.tree;
	let checked = tree.state.selectedCode == holder.record.code; 

	let buttonExpandOrCollapse = null;
	if( ! props.holder.record.leaf ) {
		if( props.holder.state.isCollapsed ) {
			buttonExpandOrCollapse = (
				<button type='button' onClick={holder.expand} style={buttonStyle} >+</button>
			);
		} else {
			buttonExpandOrCollapse = (
				<button type='button' onClick={holder.collapse} style={buttonStyle} >-</button>
			);
		}
	}
	
	return (
		<div style={{display: 'flex'}}>
			<div style={{flexGrow: 0}}>
				{buttonExpandOrCollapse}
			</div>
			<div style={{flexGrow: 0, marginLeft: '10px'}}>
				<input type='checkbox' name='cb' onChange={holder.handleCheckBoxChange} checked={checked} />
			</div>
			<div style={{flexGrow: 100, marginLeft: '5px'}}>
				{props.holder.record.name}
			</div>
		</div>
	);
}

export default KatottgNode;